<template>
	<div>
		<flCabecalhoForm
			:msg="_traducao('global', 'obrigatorio')"
			cls="print-titulo-form-20"
			:texto="'Tipo do Usuário'"
		/>

		<div class="row">
			<div class="col-xs-12 form-group" :class="{'has-error': erroTipo != ''}">
				<label>{{ _traducao('global', 'tipoDeUsuario') }}:</label><br />

				<div class="btn-group" role="group" aria-label="...">
					<button
						type="button"
						@click="
							tipo = 'O'
							limpaForm()
						"
						:class="{'btn-info': tipo == 'O'}"
						class="btn btn-default btn-sm"
					>
						{{ _traducao('global', 'operacional').toUpperCase() }}
					</button>
					<button
						type="button"
						@click="
							tipo = 'S'
							limpaForm()
						"
						:class="{'btn-info': tipo == 'S'}"
						class="btn btn-default btn-sm"
					>
						{{ _traducao('global', 'solicitante').toUpperCase() }}
					</button>
				</div>
				<p class="help-block" v-if="erroTipo != ''">{{ erroTipo }}</p>
			</div>
		</div>

		<div class="row" v-if="tipo == 'O'">
			<div class="col-xs-12 col-md-3 form-group">
				<label
					><span class="no-print"></span
					>{{ _traducao('menuOrgaoApoiados', 'orgao') }}:</label
				>
				<select
					v-model="form.id_orgao"
					class="form-control input-sm"
					autocomplete="off"
					autocorrect="off"
					autocapitalize="none"
				>
					<option value="">
						{{ _traducao('global', 'escolha').toUpperCase() }}
					</option>
					<option v-for="(item, idx) in orgaos" :value="item.id" :key="idx">
						{{ item.descricao }}
					</option>
				</select>
			</div>

			<div
				class="col-xs-12 col-md-3 form-group"
				:class="{'has-error': erro.cargo != ''}"
			>
				<label
					><span class="no-print">* </span
					>{{ _traducao('menuAGnovoUsuario', 'menuAGcargo') }}:</label
				>
				<select class="form-control input-sm" v-model="form.cargo">
					<option value="">
						{{ _traducao('global', 'escolha').toUpperCase() }}
					</option>
					<option v-for="(item, idx) in cargos" :value="item.id" :key="idx">
						{{ item.descricao }}
					</option>
				</select>
				<p class="help-block" v-show="erro.cargo != ''">{{ erro.cargo }}</p>
			</div>

			<div
				class="col-xs-12 col-md-3 form-group"
				:class="{'has-error': erro.nome_guerra != ''}"
			>
				<label
					><span class="no-print">* </span
					>{{ _traducao('global', 'nomeTratamento') }}:</label
				>
				<input
					type="text"
					v-model="form.nome_guerra"
					class="form-control input-sm"
				/>
				<p class="help-block" v-show="erro.nome_guerra != ''">
					{{ erro.nome_guerra }}
				</p>
			</div>

			<div class="col-xs-12 col-md-3 form-group">
				<label>{{ _traducao('menuAGnovoUsuario', 'menuAGposto') }}:</label>
				<select v-model="form.id_posto_graduacao" class="form-control input-sm">
					<option value="">
						{{ _traducao('global', 'escolha').toUpperCase() }}
					</option>
					<option v-for="(item, idx) in postos" :value="item.id" :key="idx">
						{{ item.descricao }}
					</option>
				</select>
			</div>

			<div class="col-xs-12 col-md-3 form-group" v-if="exibeMatricula">
				<label>{{ labelMatricula }}:</label>
				<input type="text" v-model="form.masp" class="form-control input-sm" />
			</div>

			<!-- SGPE -->
			<div class="col-xs-12 col-md-3 form-group" v-if="exibeSGPE != '0'">
				<label>{{_traducao('global','sgpe')}}</label>
				<input class="form-control input-sm" v-model="form.sgpe">
			</div>
			<!-- SGPE -->

		</div>

		<div class="row" v-if="tipo == 'O' && estatal == 0">
			<div class="col-xs-12">
				<flCabecalhoForm
					cls="print-titulo-form-20"
					:texto="'Bases Contratuais e Transferências'"
				/>
			</div>
		</div>

		<div v-if="tipo == 'O' && estatal == 0">
			<div class="row" v-for="(item, index) in baseContratuais" :key="index">
				<div class="col-xs-12 col-md-3 form-group">
					<label v-show="index == 0"
						><span class="no-print"></span
						>{{ _traducao('global', 'baseContratual') }}:</label
					>
					<label v-show="index != 0 && index < 2"
						><span class="no-print"></span
						>{{ _traducao('global', 'transferenciaBase') }}:</label
					>
					<select v-model="item.id_base" class="form-control input-sm">
						<option value="">
							{{ _traducao('global', 'escolha').toUpperCase() }}
						</option>
						<option v-for="(item, idx) in bases" :value="item.id" :key="idx">
							{{ item.descricao }}
						</option>
					</select>
				</div>

				<div class="col-xs-12 col-md-3 form-group">
					<label v-show="index < 2"
						><span class="no-print"></span
						>{{ _traducao('global', 'data') }}:</label
					>
					<flDateTime
						@v-model="(val) => (item.data = val)"
						:value="item.data"
						:lang="_getLangDp"
						:format="_formatDate"
						name="data"
					/>
				</div>

				<!-- NIVEL APRENDIZAGEM -->
				<div class="col-lg-2 col-xs-2 form-group" v-show="index != 0">
					<button
						class="btn btn-danger btn-sm btn-block no-print"
						type="button"
						:style="{marginTop: index < 2 ? '20px' : ''}"
						@click="removerBaseContratual(item.seq)"
					>
						<i class="fa fa-trash-o fa-fw"></i
						>{{ _traducao('global', 'remover') }}
					</button>
				</div>
			</div>

			<div class="row">
				<!-- BOTAO NOVO -->
				<div class="col-xs-12 form-group">
					<button
						class="btn btn-info btn-sm no-print"
						type="button"
						@click="addBaseContratual()"
					>
						<i class="fa fa-plus fa-fw"></i
						>{{ _traducao('global', 'adicionar') }}
					</button>
				</div>
			</div>
		</div>

		<div class="row" v-if="tipo == 'O'">
			<div class="col-xs-12">
				<flCabecalhoForm
					cls="print-titulo-form-20"
					:texto="_traducao('global', 'funcoes')"
				/>
			</div>
		</div>

		<div v-if="tipo == 'O'">
			<div v-for="(item, index) in listaFuncoes" :key="index">
				<flFuncao
					:perfis="perfis"
					:fabricantes="fabricantes"
					:licencas="licencas"
					:habilitacoes="habilitacoes"
					:funcao="item"
					:ultimaFuncao="listaFuncoes.length - 1 == index"
				/>
			</div>

			<div class="row">
				<!-- BOTAO NOVO -->
				<div class="col-xs-12 form-group">
					<button
						class="btn btn-info btn-sm no-print"
						type="button"
						@click="addFuncao()"
					>
						<i class="fa fa-plus fa-fw"></i
						>{{ _traducao('global', 'adicionar') }}
					</button>
				</div>
			</div>
		</div>

		<div class="row" v-if="tipo == 'O'">
			<div class="col-xs-12">
				<fl-emergencia
					ref="emergencia"
					@dados-emergencia="
						(item) => {
							dadosEmergencia = item
						}
					"
				/>
			</div>

			<div class="col-xs-12">
				<fl-contato-emergencial
					ref="contato_emergencia"
					@dados-contato-emergencial="
						(item) => {
							;(dadosContatoEmergencial = item.form),
								(dadosEnderecoEmergencia = item.endereco)
						}
					"
				/>
			</div>
		</div>

		<div
			class="row"
			v-if="tipo == 'S'"
			:class="{'has-error': erro.id_orgao_apoiado != ''}"
		>
			<div class="col-xs-3 form-group">
				<label>
					<span class="no-print"></span>*
					{{ _traducao('global', 'orgaoApoiado') }}:
				</label>
				<select v-model="form.id_orgao_apoiado" class="form-control input-sm">
					<option value="">
						{{ _traducao('global', 'escolha').toUpperCase() }}
					</option>
					<option
						v-for="(item, idx) in orgaosApoiados"
						:value="item.id"
						:key="idx"
					>
						{{ item.descricao }}
					</option>
				</select>
				<p class="help-block" v-show="erro.id_orgao_apoiado != ''">
					{{ erro.id_orgao_apoiado }}
				</p>
			</div>
		</div>
	</div>
</template>
<script>
import flEmergencia from '../componentes/emergencia.vue'
import flContatoEmergencial from '../componentes/contato-emergencia.vue'
import flFuncao from './funcao.vue'
export default {
	components: {
		flEmergencia,
		flContatoEmergencial,
		flFuncao
	},
	props: {
		postos: {
			type: Array
		},
		bases: {
			type: Array
		},
		cargos: {
			type: Array
		},
		menu: {
			type: Boolean
		}
	},
	data() {
		return {
			exibeSGPE: '0',

			exibeMatricula: false,
			labelMatricula: '',
			orgaos: [],
			orgaosApoiados: [],
			perfis: [],
			estatal: '',
			fabricantes: [],
			listaFuncoes: [],
			baseContratuais: [],
			licencas: [],
			habilitacoes: [],
			tipo: '',
			erroTipo: '',
			dadosEmergencia: {
				alergia: '',
				fator_rh: '',
				tipo_sanguineo: ''
			},

			dadosContatoEmergencial: {
				celular_emergencia: '',
				grau_emergencia: '',
				nome_emergencia: '',
				telefone_emergencia: ''
			},

			dadosEnderecoEmergencia: {
				bairro: '',
				cep: '',
				cidade: '',
				complemento: '',
				estado: '',
				logradouro: '',
				numero: ''
			},

			form: {
				masp: '',
				cargo: '',
				nome_guerra: '',
				id_posto_graduacao: null,
				sgpe:'',
				id_orgao: '',
				id_orgao_apoiado: '',
				base_contratual: [
					{
						id: 0,
						id_base: '',
						data: '',
						excluir: '0'
					}
				],
				funcao: [
					{
						id: 0,
						id_perfil: '',
						id_fabricante: '',
						id_modelo: '',
						data: '',
						id_licenca: '',
						numero_licenca: '',
						id_habilitacao: '',
						excluir: '0'
					}
				]
			},

			erro: {
				houve_contexto: '',
				data: '',
				cargo: '',
				nome_guerra: '',
				id_posto_graduacao: '',
				id_orgao_apoiado: ''
			}
		}
	},
	watch: {
		'tipo'(val, oldVal) {
			if (oldVal && val != oldVal) {
				if (val == 'S') {
					this.form.base_contratual = []
					this.form.funcao = []
				} else {
					this.form.base_contratual = [
						{
							id: 0,
							id_base: '',
							data: '',
							excluir: '0'
						}
					]
					this.form.funcao = [
						{
							id: 0,
							id_perfil: '',
							id_fabricante: '',
							id_modelo: '',
							data: '',
							id_licenca: '',
							numero_licenca: '',
							id_habilitacao: '',
							excluir: '0'
						}
					]
				}
			}
		},
		'form.base_contratual': {
			deep: true,
			handler() {
				this.baseContratuais = this.form.base_contratual.filter(
					(item) => item.excluir != 1
				)
			}
		},
		'form.funcao': {
			deep: true,
			handler() {
				this.listaFuncoes = this.form.funcao.filter((item) => item.excluir != 1)
			}
		}
	},
	created() {
		this._getParametro(25).then((habilitado) => {
			if (habilitado != null && Boolean(Number(habilitado)))
				this._getParametro(26).then((nome) => {
					this.labelMatricula = nome
					this.exibeMatricula = true
				})
			else this.exibeMatricula = false
		})
		this._getParametro(73).then((parametro) => {
			this.exibeSGPE = parametro
		})
	},
	mounted() {
		this.carregarDados()
		this.carregarEventos()
		this.carregarLicencas()
		this.carregarHabilitacoes()
		this.verificaEstatal()
	},
	methods: {
		carregarDados() {
			bus.$emit('load-in', {text: this._traducao('global', 'carregando')})
			this._axios('/Orgao/get_orgao', 'get', {
				callback: (retorno) => {
					if (retorno._request && retorno._status) {
						this.orgaos = retorno.lista
					}
				},
				finally: () => {
					bus.$emit('load-out')
				}
			})

			bus.$emit('load-in', {text: this._traducao('global', 'carregando')})
			this._axios('/Orgao_apoiado/get', 'get', {
				callback: (retorno) => {
					if (retorno._request && retorno._status) {
						this.orgaosApoiados = retorno.lista
					}
				},
				finally: () => {
					bus.$emit('load-out')
				}
			})

			bus.$emit('load-in', {text: this._traducao('global', 'carregando')})
			this._axios('/Funcao_bordo/listar', 'get', {
				callback: (retorno) => {
					if (retorno._request && retorno._status) {
						this.perfis = retorno.lista
					}
				},
				finally: () => {
					bus.$emit('load-out')
				}
			})

			bus.$emit('load-in', {text: this._traducao('global', 'carregando')})
			this._axios('/Fabricante/get', 'get', {
				callback: (retorno) => {
					if (retorno._request && retorno._status) {
						this.fabricantes = retorno.lista
					}
				},
				finally: () => {
					bus.$emit('load-out')
				}
			})
		},

		verificaEstatal() {
			this._getParametro(21).then((valor) => (this.estatal = valor))
		},

		carregarEventos() {
			window.bus.$on('remover-funcao', (seq) => {
				const index = this.form.funcao.findIndex((item) => item.seq == seq)
				if (index >= 0) {
					this.form.funcao[index].excluir = 1
				}
			})
		},

		carregarLicencas() {
			bus.$emit('load-in', {text: this._traducao('global', 'carregando')})
			this._axios(`/Licenca/get`, 'get', {
				callback: (retorno) => {
					if (retorno._request && retorno._status) {
						this.licencas = retorno.lista
					}
				},
				finally: () => {
					bus.$emit('load-out')
				}
			})
		},

		carregarHabilitacoes() {
			bus.$emit('load-in', {text: this._traducao('global', 'carregando')})
			this._axios(`/Habilitacao/get`, 'get', {
				callback: (retorno) => {
					if (retorno._request && retorno._status) {
						this.habilitacoes = retorno.lista
					}
				},
				finally: () => {
					bus.$emit('load-out')
				}
			})
		},

		addBaseContratual() {
			this.form.base_contratual.push({
				id: 0,
				id_base: '',
				data: '',
				excluir: '0'
			})

			this.ordena()
		},

		addFuncao() {
			this.form.funcao.push({
				id: 0,
				id_perfil: '',
				id_fabricante: '',
				id_modelo: '',
				data: '',
				id_licenca: '',
				numero_licenca: '',
				id_habilitacao: '',
				excluir: '0'
			})

			this.ordena()
		},

		ordena: function () {
			this.form.base_contratual = this.form.base_contratual.map(function (
				item,
				index
			) {
				item.seq = index + 1
				return item
			})

			this.form.funcao = this.form.funcao.map(function (item, index) {
				item.seq = index + 1
				return item
			})
		},

		removerBaseContratual(seq) {
			const index = this.form.base_contratual.findIndex(
				(item) => item.seq == seq
			)
			if (index >= 0) {
				this.form.base_contratual[index].excluir = 1
			}
		},
		editar(item) {
			this.form.masp = item.masp
			this.form.data = this._SQLDateToDate(item.data, $sessao.getDateFormat())
			this.form.cargo = item.cargo
			this.form.nome_guerra = item.nome_guerra
			this.form.id_posto_graduacao = item.id_posto_graduacao
			this.form.sgpe = item.sgpe
			this.tipo = item.tipo
			this.form.id_orgao = item.id_orgao
			this.form.id_orgao_apoiado = item.id_orgao_apoiado

			if (item.base_contratual) {
				this.form.base_contratual = item.base_contratual
			}
			if (item.funcao) {
				this.form.funcao = item.funcao
			}

			if (this.tipo == 'O') {
				this.$nextTick(() => {
					this.$refs.emergencia.editar(item)
				})
				this.$nextTick(() => {
					this.$refs.contato_emergencia.editar(item)
				})
			}

			this.ordena()

			this.$forceUpdate()
		},
		limpaForm() {
			this.dadosEmergencia = {
				alergia: '',
				fator_rh: '',
				tipo_sanguineo: ''
			}

			this.dadosContatoEmergencial = {
				celular_emergencia: '',
				grau_emergencia: '',
				nome_emergencia: '',
				telefone_emergencia: ''
			}

			this.dadosEnderecoEmergencia = {
				bairro: '',
				cep: '',
				cidade: '',
				complemento: '',
				estado: '',
				logradouro: '',
				numero: ''
			}

			this.form = {
				masp: '',
				data: '',
				cargo: '',
				nome_guerra: '',
				id_posto_graduacao: null,
				sgpe:'',
				id_orgao: '',
				id_orgao_apoiado: '',
				base_contratual: [
					{
						id: 0,
						id_base: '',
						data: '',
						excluir: '0'
					}
				],
				funcao: [
					{
						id: 0,
						id_perfil: '',
						id_fabricante: '',
						id_modelo: '',
						data: '',
						id_licenca: '',
						numero_licenca: '',
						id_habilitacao: '',
						excluir: '0'
					}
				]
			}

			this.erroTipo = ''

			this.erro = {
				houve_contexto: '',
				data: '',
				cargo: '',
				nome_guerra: '',
				id_posto_graduacao: '',
				id_orgao_apoiado: ''
			}

			this.ordena()
		},

		validaForm() {
			let passou = true
			let obg = this._traducao('global', 'campoObrigatorio')

			if (this.tipo == '') {
				this.erroTipo = obg
				passou = false
			} else {
				this.erroTipo = ''
			}

			if (this.tipo == 'O') {
				if (this.form.cargo == '') {
					this.erro.cargo = obg
					passou = false
				} else {
					this.erro.cargo = ''
				}

				if (this.form.nome_guerra == '') {
					this.erro.nome_guerra = obg
					passou = false
				} else {
					this.erro.nome_guerra = ''
				}

				if (!this.$refs.emergencia.validaForm()) {
					passou = false
				}

				if (!this.$refs.contato_emergencia.validaForm()) {
					passou = false
				}
			}

			if (this.tipo == 'S') {
				if (!this.form.id_orgao_apoiado) {
					this.erro.id_orgao_apoiado = obg
					passou = false
				} else {
					this.erro.id_orgao_apoiado = ''
				}
			}

			if (passou) {
				this.$emit('dados-adicionais', {
					form: this.form,
					dados: this.dadosEmergencia,
					contato: this.dadosContatoEmergencial,
					endereco: this.dadosEnderecoEmergencia,
					tipo: this.tipo
				})
			}

			return passou
		}
	}
}
</script>